import axios from 'axios';
import extend from 'extend';
import qs from 'qs';

const apiUrl = {
	// 'development' : 'https://local.weixin.api.bei-lin.cn/wechat',
	'development' : 'https://weixin2.api.bei-lin.cn/wechat',
    'testing' : 'https://test.weixin.api.bei-lin.cn/wechat',
    // 'production' : 'https://weixin.api.bei-lin.cn/wechat',
    'production' : 'https://weixin2.api.bei-lin.cn/wechat',
};

export default {
    REQUEST_URL_PREFIX : apiUrl[process.env.NODE_ENV],
    ERROR_CALLBACK : [],
    FAIL_CALLBACK : [],
    BEFORE_CALLBACK : [],
    globalBefore : true,
    globalError : true,
    globalFail : true,
    before(callback){
        this.BEFORE_CALLBACK.push(callback);
    },
    error(callback){
        this.ERROR_CALLBACK.push(callback);
    },
    fail(callback){
        this.FAIL_CALLBACK.push(callback);
    },
    request(interfaceURL, data = {}, options = {}){
        let self = this;
        options = extend(true, {
            baseURL : this.REQUEST_URL_PREFIX,
            url : interfaceURL,
            method : 'POST',
            data : data,
            transformRequest: [
                function (data) {
                    if(data instanceof FormData) return data;
                    return qs.stringify(data);
                }
            ],
            headers : {
                // 'Content-Type' : 'application/x-www-form-urlencoded',
            },
            returnResponse : false,  //是否返回响应
            error(err){
                console.error(err);
            },
            // timeout : 60 * 1000,
        }, options);

        if(self.globalBefore){
            for (let i = 0; i < self.BEFORE_CALLBACK.length; i++){
                if(self.BEFORE_CALLBACK[i](options) === false)
                    break;
            }
        }

        return new Promise(async (resolve, reject) => {
            axios(options).then(response => {
                let res = options.returnResponse ? response : response.data;
                if(response.data.code === 0) {
                    resolve(res);
                } else {
                    if(self.globalFail){
                        for (let i = 0; i < self.FAIL_CALLBACK.length; i++){
                            if(self.FAIL_CALLBACK[i](res) === false)
                                break;
                        }
                    }
                    reject(res);
                }
            }).catch(err => {
                if(self.globalError){
                    for (let i = 0; i < self.ERROR_CALLBACK.length; i++){
                        if(self.ERROR_CALLBACK[i](err) === false)
                            break;
                    }
                }
                options.error(err);
            });
        });
    },
};



// WEBPACK FOOTER //
// ./src/assets/js/api.js